import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class AuthRequest extends Request {
    constructor(login, pass_hash, generate_auth_token) {
        super({
            req: RequestTypes.AUTH,
            req_id: 0,
            login: login,
            pass_hash: pass_hash,
            generate_auth_token: generate_auth_token
        });
    }
}

export default AuthRequest;